module.exports = __webpack_public_path__ + "img/pt-single-6.dd830245.jpg";